"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DashboardObject_1 = require("./DashboardObject");
const Sheet_1 = require("./Sheet");
const StoryPoint_1 = require("./StoryPoint");
const Worksheet_1 = require("./Worksheet");
class Dashboard extends Sheet_1.Sheet {
    constructor(_dashboardImpl, workbookImpl) {
        super(_dashboardImpl, workbookImpl);
        this._dashboardImpl = _dashboardImpl;
        _dashboardImpl.initializeWithPublicInterfaces();
    }
    get objects() {
        return this._dashboardImpl.objects.map((object) => {
            return new DashboardObject_1.DashboardObject(object, this._workbookImpl);
        });
    }
    get worksheets() {
        return this._dashboardImpl.worksheetsImpl.map((object) => {
            return new Worksheet_1.Worksheet(object, this._workbookImpl);
        });
    }
    get parentStoryPoint() {
        if (this._dashboardImpl.parentStoryPoint == null) {
            // Dashboard doesn't belong to a story point. Return null.
            return null;
        }
        return new StoryPoint_1.StoryPoint(this._dashboardImpl.parentStoryPoint, this._workbookImpl);
    }
    getFiltersAsync() {
        return this._dashboardImpl.getFiltersAsync();
    }
    applyFilterAsync(fieldName, values, updateType, options) {
        return this._dashboardImpl.applyFilterAsync(fieldName, values, updateType, options);
    }
}
exports.Dashboard = Dashboard;
//# sourceMappingURL=Dashboard.js.map